import { RoleType } from '@/shared/types/member';

import { ADMIN, BUILDER, CHAT_AGENT, CHAT_MANAGER } from './constants';

/**
 * Returns an object indicating the user's roles based on their role IDs and account role.
 *
 * @param {string[]} role_ids - Array of role IDs associated with the user.
 * @param {string} accountRole - The account role type (e.g., owner, admin).
 * @returns {Object} - An object indicating whether the user is a builder, chat manager, admin, or chat agent.
 */
export const getRoles = (role_ids: string[], accountRole: string) => {
  const isChatAgent = role_ids?.includes(CHAT_AGENT);
  const isBuilder = role_ids?.includes(BUILDER);
  const isChatManager = role_ids?.includes(CHAT_MANAGER);
  const isAdminOrOwner = role_ids?.includes(ADMIN) || accountRole === RoleType.OWNER;
  return { isBuilder, isChatManager, isAdminOrOwner, isChatAgent };
};
